export default __webpack_public_path__ + "static/media/ngNewQuestions.68bc9d2c.JPG";